import MainPagePresenter from "./MainPagePresenter";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { Routes, Route } from "react-router-dom";
import BasePage from "../../base/BasePage";
import { Layout } from "../../nq-component";
import withRouter from "../../utils/withRouter";
import Sidebar from "./components/sidebar";
import NavBar from "../../components/NavBar/Navbar";
import menus from "./config/menus.json";
import ProfileListPage from "../main-pages/user-profile-and-access/user-profile/profile-list-page/ProfileListPage";
import ProfileFormPage from "../main-pages/user-profile-and-access/user-profile/profile-form-page/ProfileFormPage";
import ManageClientListPage from "../main-pages/manage-client/manage-client-list/ManageClientListPage";
import ManageClientFormPage from "../main-pages/manage-client/manage-client-form/ManageClientFormPage";
import AffiliateBranchesListPage from "../main-pages/affiliate-branches/affiliate-branches-list/AffiliateBranchesListPage";
import AffiliateBranchesFormPage from "../main-pages/affiliate-branches/affiliate-branches-form/AffiliateBranchesFormPage";
import NewsFormPage from "../main-pages/news/news-form/NewsFormPage";
import NewsListPage from "../main-pages/news/news-list/NewsListPage";
import RecordListPage from "../main-pages/records/records-list/RecordListPage";
import RecordFormPage from "../main-pages/records/record-form/RecordFormPage";
import PendingListPage from "../main-pages/user-profile-and-access/user-pending/pending-list-page/PendingListPage";
import AffiliateDirectoryListPage from "../main-pages/affiliate-directory/affiliate-directory-list/AffiliateDirectoryListPage";
import BillingListPage from "../main-pages/credit-management/billing/billing-list/BillingListPage";
import BillingLogsListPage from "../main-pages/credit-management/billing-logs/billing-logs-list/BillingLogsListPage";
import UnlockingListPage from "../main-pages/unlocking/unlocking-list/UnlockingListPage";
import Progress from "../../components/Progress";
import NegativeRecordsListPage from "../main-pages/negative-records/negative-records-list/NegativeRecordsListPage";
import NegativeRecordsViewPage from "../main-pages/negative-records/negative-records-view/NegativeRecordsViewPage";
import UnlockingDetailsPage from "../main-pages/unlocking/unlocking-details/UnlockingDetailsPage";
import SearchLogsListPage from "../main-pages/search-logs/SearchLogsListPage";
import ProfileViewPage from "../main-pages/profile/profile-view/ProfileViewPage";
import EditProfileFormPage from "../main-pages/profile/profile-form/EditProfileFormPage";
import SingleSearchLogsListPage from "../main-pages/credit-management/billing/search-logs/SingleSearchLogsListPage";
import PendingUserDetailsPage from "../main-pages/user-profile-and-access/user-pending/pending-user-details-page/PendingUserDetailsPage";
import AccessHistoryListPage from "../main-pages/negative-records/access-history-list/AccessHistoryListPage";
import NegativeRecordsCompanyListPage from "../main-pages/negative-records/negative-records-company-list/NegativeRecordsCompanyListPage";
import CreditListPage from "../main-pages/credit-management/credit-topup/credit-list/CreditListPage";
import CreditLogsPage from "../main-pages/credit-management/credit-topup/credit-logs/CreditLogsPage";
import CreditInActiveListPage from "../main-pages/credit-management/credit-topup/credit-list/CreditInActiveListPage";
import NegativeRecordsCompanyViewPage from "../main-pages/negative-records/negative-records-company-view/NegativeRecordsCompanyViewPage";
import UserlogsPage from "../main-pages/user-profile-and-access/user-profile/user-logs-page/UserlogsPage";
import RecordCompanyListPage from "../main-pages/records-company/records-list/RecordCompanyListPage";
import RecordCompanyFormPage from "../main-pages/records-company/record-form/RecordCompanyFormPage";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase(),
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  render() {
    const user = this.getCurrentUser();
    const schemas = this.getSchemas();

    if (!user || !schemas) {
      return (
        <div className="d-flex vh-100 justify-content-center align-align-items-center">
          <Progress />
        </div>
      );
    }

    return (
      <Layout>
        <Layout.Context.Consumer>
          {(value) => (
            <Sidebar
              value={value}
              user={user}
              buttonLabel="Sign Out"
              onClickMenu={this.onClickMenu.bind(this)}
              onClick={this.onClickSignOut.bind(this)}
              menu={menus}
            />
          )}
        </Layout.Context.Consumer>
        <main
          className="d-flex flex-column overflow-hidden"
          style={{ height: "100vh" }}
        >
          <NavBar />
          <Routes>
            <Route
              exact
              path={"/affiliates"}
              element={<ManageClientListPage />}
            />
            <Route
              exact
              path={"/affiliates/form"}
              element={<ManageClientFormPage />}
            />
            <Route
              exact
              path={"/affiliates/form/:id"}
              element={<ManageClientFormPage />}
            />
            <Route
              exact
              path={"/branches"}
              element={<AffiliateBranchesListPage />}
            />
            <Route
              exact
              path={"/branches/form"}
              element={<AffiliateBranchesFormPage />}
            />
            <Route
              exact
              path={"/branches/form/:id"}
              element={<AffiliateBranchesFormPage />}
            />
            <Route exact path={"/profile"} element={<ProfileListPage />} />
            <Route exact path={"/profile/form"} element={<ProfileFormPage />} />
            <Route
              exact
              path={"/profile/form/:id"}
              element={<ProfileFormPage />}
            />
            <Route
              exact
              path={"/profile/user-logs/:id"}
              element={<UserlogsPage />}
            />
            <Route exact path={"/pending"} element={<PendingListPage />} />
            <Route
              exact
              path={"/pending/:id"}
              element={<PendingUserDetailsPage />}
            />

            <Route exact path={"/unlocking"} element={<UnlockingListPage />} />
            <Route
              exact
              path={"/unlocking/:id"}
              element={<UnlockingDetailsPage />}
            />
            <Route exact path={"/news"} element={<NewsListPage />} />
            <Route exact path={"/news/form"} element={<NewsFormPage />} />
            <Route exact path={"/news/form/:id"} element={<NewsFormPage />} />
            <Route exact path={"/billing"} element={<BillingListPage />} />
            <Route exact path={"/top-up"} element={<CreditListPage />} />
            <Route
              exact
              path={"/top-up/inactive"}
              element={<CreditInActiveListPage />}
            />
            <Route
              exact
              path={"/credit-logs/:id"}
              element={<CreditLogsPage />}
            />
            <Route
              exact
              path={"/billing/search-logs/:id"}
              element={<SingleSearchLogsListPage />}
            />
            <Route
              exact
              path={"/billing-logs"}
              element={<BillingLogsListPage />}
            />
            <Route exact path={"/records"} element={<RecordListPage />} />
            <Route exact path={"/records/form"} element={<RecordFormPage />} />
            <Route
              exact
              path={"/company/records"}
              element={<RecordCompanyListPage />}
            />
            <Route
              exact
              path={"/company/records/form"}
              element={<RecordCompanyFormPage />}
            />
            <Route
              exact
              path={"/records/form/:id"}
              element={<RecordFormPage />}
            />

            {/* AFFILIATE PAGES */}
            <Route
              exact
              path={"/affiliate-directory"}
              element={<AffiliateDirectoryListPage />}
            />
            <Route
              exact
              path={"/negative-records"}
              element={<NegativeRecordsListPage />}
            />
            <Route
              exact
              path={"/negative-records/company"}
              element={<NegativeRecordsCompanyListPage />}
            />
            <Route
              exact
              path={"/negative-records/:id"}
              element={<NegativeRecordsViewPage />}
            />
            <Route
              exact
              path={"/negative-records/company/:id"}
              element={<NegativeRecordsCompanyViewPage />}
            />

            <Route
              exact
              path={"/negative-records/:id/history/:searchNameId"}
              element={<AccessHistoryListPage />}
            />
            <Route
              exact
              path={"/search-logs"}
              element={<SearchLogsListPage />}
            />
            <Route exact path={"/my-profile"} element={<ProfileViewPage />} />
            <Route
              exact
              path={"/my-profile/:id"}
              element={<EditProfileFormPage />}
            />
          </Routes>
        </main>
      </Layout>
    );
  }
}

export default withRouter(MainPage);
